import { Button } from "antd";
import { AddLabelForm } from "components/Forms/LabelsForm/AddLabelForm.tsx";
import { Drawer } from "components/UI/Drawer";
import { DrawerTitle } from "components/UI/DrawerTitle/DrawerTitle.tsx";
import { useDrawer } from "hooks/useDrawer.ts";
import { usePaldockTranslation } from "hooks/usePaldockTranslation";
import { FC } from "react";
import { DrawerId, FormId } from "types/models.ts";

interface AddLabelDrawerProps {
    onSuccess: () => void;
}

export const AddLabelDrawer: FC<AddLabelDrawerProps> = ({ onSuccess }) => {
    const { t } = usePaldockTranslation("drawers.add-label");
    const { t: tC } = usePaldockTranslation("common");
    const drawerId = DrawerId.AddLabel;
    const { hide } = useDrawer();

    return (
        <Drawer
            drawerId={drawerId}
            title={<DrawerTitle mainTitle={t("title")} />}
            extraButtons={
                <Button size={"large"} htmlType="submit" type={"primary"} form={FormId.AddLabel}>
                    {tC("save")}
                </Button>
            }
        >
            <AddLabelForm
                onSuccess={() => {
                    onSuccess();
                    hide(drawerId);
                }}
            />
        </Drawer>
    );
};
